import styled from "styled-components";

export const LoaderMain = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
`;

export const LoaderPadding = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LoaderInner = styled.div`
    width: 300px;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const LoaderIcon = styled.div`
    font-size: 50px;
`;

export const LoaderMessage = styled.div`
    font-size: 16px;
`;